export const deepCopy = <T>(obj: T, type: 'basic' | 'clone' = 'basic'): T => {
  if (typeof obj === 'object' && type === 'basic') {
    return JSON.parse(JSON.stringify(obj));
  }

  if (type === 'clone') {
    return structuredClone(obj);
  }

  return obj;
};
